module.exports = __webpack_public_path__ + "static/media/fWINGS.b96e7534.svg";